import { reportError } from '@/utils/error-reporting'
import FeatureController from '@controllers/FeatureController'
import axios from 'axios'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFeatureFlagStore = defineStore('features', () => {
  const features = ref<Record<string, boolean>>({})

  const loadFeatures = () => {
    axios
      .get(FeatureController().url)
      .then((response) => {
        if (response.data && response.data.features) {
          features.value = response.data.features
        }
      })
      .catch((error: unknown) => reportError('Loading the feature flags failed', error))
  }

  loadFeatures()

  const enabled = (feature: string) => {
    if (features.value[feature] === undefined) {
      return false
    }
    return features.value[feature]
  }

  return { features, enabled, loadFeatures }
})
